"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "BEWEI BODY",
  description: "Erleben Sie die transformative Kraft der BEWEI-Methode. Durch sanfte elektromagnetische Wellen wird Ihr Zellstoffwechsel angeregt, was zu einer sichtbaren Straffung des Gewebes und einer revitalisierten Körperkontur führt.",
  image: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/bewei-liege-model-1-669f3488.jpg?v=0123c9nt5jo",
  to: "/bewei-body/",
  linkText: "Mehr erfahren"
}, {
  title: "BEWEI HANDS",
  description: "Geben Sie Ihren Händen die Aufmerksamkeit, die sie verdienen. Diese spezialisierte Anwendung reduziert Pigmentflecken, glättet die Hautstruktur und verleiht Ihren Händen ein jugendliches, gepflegtes Aussehen.",
  image: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/bewei_hands_byLinda.jpg?v=wtpnu9xblda",
  to: "/bewei-hands/",
  linkText: "Mehr erfahren"
}, {
  title: "BEWEI FACE",
  description: "Ein strahlender Auftritt beginnt bei der Hautpflege. Unsere Gesichtsbehandlung nutzt innovative Technologie, um die Kollagenproduktion zu stimulieren, Fältchen zu mildern und Ihre natürlichen Gesichtskonturen sanft zu betonen.",
  image: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/bodyconcept_BEWEI_face2-scaled.jpg?v=7niaj65h97g",
  to: "/bewei-face/",
  linkText: "Mehr erfahren"
}, {
  title: "Lymphdrainage",
  description: "Gönnen Sie Ihrem Körper eine Auszeit und fördern Sie den natürlichen Reinigungsprozess. Die mechanische Lymphdrainage hilft effektiv dabei, Wassereinlagerungen zu reduzieren und das allgemeine Wohlbefinden nachhaltig zu steigern.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/lymphdrainage.png",
  to: "/lymphdrainage/",
  linkText: "Mehr erfahren"
}, {
  title: "Schlank im Liegen",
  description: "Erreichen Sie Ihre ästhetischen Ziele ganz entspannt. Durch den Einsatz spezifischer Frequenzen werden Fettzellen gezielt angesprochen und die Muskulatur gestärkt, während Sie in ruhiger Atmosphäre regenerieren.",
  image: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/bodyconcept_SchlankimLiegen2.jpg?v=0bdexpg13r8t",
  to: "/schlank-im-liegen/",
  linkText: "Mehr erfahren"
}, {
  title: "EMP Chair",
  description: "Revolutionäre Technologie für Ihre innere Stärke. Das intensive Beckenbodentraining im Sitzen verbessert nicht nur Ihre Körperhaltung, sondern schenkt Ihnen neue Vitalität und Sicherheit im Alltag.",
  image: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/Bodyconcept_linda_EMPchair.jpg?v=g3wrbgww98d",
  to: "/emp-chair/",
  linkText: "Mehr erfahren"
}];
function ServiceBlock({
  service,
  index
}: {
  service: typeof services[0];
  index: number;
}) {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const isEven = index % 2 === 0;
  const isTopAligned = service.title === "BEWEI BODY" || service.title === "BEWEI HANDS";
  return <div id="loesungen" data-section-id="224793" data-index={index} className="w-full py-20 lg:py-32 bg-muted">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className={`flex flex-col lg:flex-row gap-12 lg:gap-24 items-center ${isEven ? '' : 'lg:flex-row-reverse'}`}>
          
          <div ref={imgRef} className={`w-full lg:w-1/2 transition-all duration-1000 ease-out ${isImgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            <div className="relative aspect-[4/3] overflow-hidden bg-muted rounded-3xl shadow-sm">
              <img src={service.image} alt={service.title} className={`w-full h-full object-cover transition-transform duration-1000 hover:scale-105 ${isTopAligned ? 'object-top' : ''}`} />
              <div className="absolute inset-0 border border-accent/10 pointer-events-none rounded-3xl" />
            </div>
          </div>

          <div ref={textRef} className={`w-full lg:w-1/2 flex flex-col items-start transition-all duration-1000 delay-200 ease-out ${isTextVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="w-8 h-[1px] bg-accent block"></span>
              <span className="text-muted-foreground font-default font-medium tracking-widest uppercase text-sm">
                Lösung 0{index + 1}
              </span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-semibold text-foreground mb-6 leading-tight tracking-tight">
              {service.title}
            </h2>
            
            <p className="text-lg font-default text-muted-foreground mb-10 leading-relaxed max-w-lg">
              {service.description}
            </p>
            
            <Link to={service.to} className="inline-flex items-center gap-2 border border-primary text-foreground hover:bg-accent hover:text-primary transition-all duration-300 rounded-lg px-8 h-11 text-base font-medium">
              {service.linkText}
              <ArrowRight className="size-4" />
            </Link>
          </div>

        </div>
      </div>
    </div>;
}
export default function OurEliteServices() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="unsere-lösungen" className="w-full flex flex-col bg-background text-foreground">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl pt-24 pb-12 text-center">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-4xl md:text-5xl font-default font-semibold text-foreground mb-4 tracking-tighter">
            UNSERE LÖSUNGEN
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default leading-relaxed">
            Ganzheitliche Anwendungen für Ihr körperliches Wohlbefinden und eine strahlende Erscheinung, abgestimmt auf Ihre individuellen Ziele.
          </p>
        </div>
      </div>

      {services.map((service, index) => <ServiceBlock key={index} service={service} index={index} />)}
    </section>;
}